import { useEffect } from "react";
import useSeo from "../lib/useSeo";

/**
 * `/happy-plate` used to host the Plate Buddies preorder page. As of
 * 2026-02, Happy Plate has spun out; the investor material now lives at
 * `/investors` on this same platebuddies.com domain (unified brand system).
 *
 * This tiny redirect page catches old bookmarks / SEO backlinks / email
 * campaigns pointing at `/happy-plate` and forwards them to the new home.
 * `window.location.replace` keeps the old URL out of the user's back-button
 * history so a return-nav doesn't loop them here.
 *
 * SEO: emits noindex,nofollow so Google drops the old URL from search.
 * Before this fix, the stale meta title "Overview, Execution Plan & Financial"
 * (leaking from the makeahappyplate deck) was showing in SERP for
 * platebuddies.com/happy-plate — awful for parent trust.
 */
export default function HappyPlateRedirect() {
  useSeo({
    title: "Redirecting… — Plate Buddies",
    description: "This page has moved.",
    noIndex: true,
  });
  useEffect(() => {
    // Internal redirect keeps everything on-domain and unifies the brand.
    window.location.replace("/investors");
  }, []);
  return (
    <div style={{ padding: "80px 24px", textAlign: "center", color: "#6b6255", fontFamily: "system-ui, sans-serif" }}>
      Redirecting…{" "}
      <a href="/investors" style={{ color: "#F26A34", fontWeight: 700 }}>
        Continue →
      </a>
    </div>
  );
}
